const STORAGE_KEY = 'recent-batch-imports'
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000
const MAX_ENTRIES = 50

export type TRecentBatchImport = {
  batchImportToken: string
  projectId: number
  createdAt: number
  interopLogIds?: number[]
  dataCount: number
}

const isFresh = (entry: TRecentBatchImport, now: number) =>
  typeof entry?.batchImportToken === 'string' &&
  typeof entry.createdAt === 'number' &&
  now - entry.createdAt < MAX_AGE_MS

const readAll = (): TRecentBatchImport[] => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    const parsed: unknown = stored ? JSON.parse(stored) : []
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

const writeAll = (entries: TRecentBatchImport[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
  } catch {
    // storage unavailable: imports can still be reopened from the URL they were opened at
  }
}

// Reads drop entries older than a week (and persist the cleanup), so the list never outlives its limit
const readFresh = (now: number): TRecentBatchImport[] => {
  const entries = readAll()
  const fresh = entries.filter((entry) => isFresh(entry, now))
  if (fresh.length !== entries.length) writeAll(fresh)
  return fresh
}

export const getRecentBatchImport = (batchImportToken: string, now = Date.now()) =>
  readFresh(now).find((entry) => entry.batchImportToken === batchImportToken)

export const saveRecentBatchImport = (entry: TRecentBatchImport, now = Date.now()) => {
  const others = readFresh(now).filter(({ batchImportToken }) => batchImportToken !== entry.batchImportToken)
  writeAll([entry, ...others].slice(0, MAX_ENTRIES))
}
